import { ICustomerUpdateRequestsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisCustomerUpdateRequestsRepository from './implementations/VectisCustomerUpdateRequestsRepository';

let instance: ICustomerUpdateRequestsRepository | null = null;

export default function makeCustomerUpdateRequestsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisCustomerUpdateRequestsRepository(httpProvider);
  }

  return instance;
}
